'use client';

import { usePathname } from 'next/navigation';

import { Info } from '@gds/Icons/Paths/Info';
import { Typography } from '@gds/Typography/Typography';
import { useModal } from '@modal/Hooks/UseModal';

import styles from './LegalDisclaimers.module.css';

interface LegalDisclaimersProps {
  header: string;
  content: string;
}

export const LegalDisclaimers = ({ header, content }: LegalDisclaimersProps) => {
  const { openModal } = useModal();
  const pathname = usePathname();

  const handleOpenModal = () => {
    openModal(
      <Typography variant="body3" Component="p" className={styles.description}>
        <div dangerouslySetInnerHTML={{ __html: content || '' }} />
      </Typography>,
      {
        header: header,
        modalClassName: styles.modalContainer,
        modalBodyClassName: styles.modalBody,
      },
    );
  };

  if (pathname.includes('/finance-deal')) return null;

  return (
    <span className={styles.infoIcon}>
      {content && <Info onClick={handleOpenModal} fontSize={20} />}
    </span>
  );
};
